// ================= plugin import ================ //
import React,{useEffect} from 'react'
// =============== component import ============ //
import { MenuComponent } from '../../../../../../_template/assets/ts/components/MenuComponent'
import InformationPopup from '../../../../../component/common/InformationPopup'
import ResponsePopup from '../../../../../component/common/ResponsePopup'
const InformationList = (props) => {
    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization();
        }, 500);
    }, []);
    const { 
        information_item,
        example,
        select_response,
        final_response,
        fail_response,
        initial_response,
        action_name,
        folow_up_details,
        affiram_or_deny,
        closing_utterance,
        feedback
    } = props;
    let followUpTitle = '';
    let followUpValue = '';
    if(folow_up_details?.value === 'opt_in'){
        followUpTitle = 'Affirm or Deny';
        followUpValue = affiram_or_deny;
    }
    else if(folow_up_details?.value === 'closing_utterance'){
        followUpTitle = 'Closing Utterance';
        followUpValue = closing_utterance;
    }
    else if(folow_up_details?.value === 'feedback'){
        followUpTitle = 'Feedback';
        followUpValue = feedback;
    }
    return(
        <>
            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                <div className="row mb-3">
                    <label className="col-lg-3 fw-semibold text-muted">
                        Information Item
                    </label>
                    <div className="col-lg-9">
                        <span className="fw-bold fs-6 text-gray-800">
                            {information_item}
                        </span>
                    </div>
                </div>
                <div className="row mb-3">
                    <label className="col-lg-3 fw-semibold text-muted">
                        Example
                    </label>
                    <div className="col-lg-9">
                        <span className="fw-bold fs-6 text-gray-800">
                            {example}
                        </span>
                    </div>
                </div>
                <div className="row mb-3">
                    <label className="col-lg-3 fw-semibold text-muted">
                        Response Type
                    </label>
                    <div className="col-lg-9">
                        <span 
                            className="fw-bold fs-6 text-primary cursor-pointer"
                            data-sai-menu-trigger='click'
                            data-sai-menu-placement='bottom-end'
                            data-sai-menu-flip='top-end'
                        >
                            {select_response?.label}
                        </span>
                        <ResponsePopup
                            final_response={final_response}
                            fail_response={fail_response}
                            initial_response={initial_response}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <label className="col-lg-3 fw-semibold text-muted">
                        Action
                    </label>
                    <div className="col-lg-9">
                        <span className="fw-bold fs-6 text-gray-800">
                            {action_name}
                        </span>
                    </div>
                </div>
                <div className="row mb-3">
                    <label className="col-lg-3 fw-semibold text-muted">
                        Follow up details
                    </label>
                    <div className="col-lg-9">
                        <span 
                            className="fw-bold fs-6 text-primary cursor-pointer"
                            data-sai-menu-trigger='click'
                            data-sai-menu-placement='bottom-end'
                            data-sai-menu-flip='top-end'
                        >
                            {followUpTitle}
                        </span>
                        <InformationPopup
                            title= {followUpTitle}
                            info= {followUpValue}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
const Information = (props) => {
    const { information_data } = props;
    let informationData = '';
    if( information_data.length > 0 ){
        informationData = information_data.map((infoData,i) => 
            <InformationList
                key={i}
                information_item={infoData.information_item}
                example={infoData.example}
                select_response={infoData.select_response}
                final_response={infoData.final_response}
                fail_response={infoData.fail_response}
                initial_response={infoData.initial_response}
                action_name={infoData.action_name}
                folow_up_details={infoData.folow_up_details}
                affiram_or_deny={infoData.affiram_or_deny}
                closing_utterance={infoData.closing_utterance}
                feedback={infoData.feedback}
            />
        )
    }
    return (
        <>
            <div className='row'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Information
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 2 information are available
                                </span>
                            </h3>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-5">
                            {informationData}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Information